import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

const calculableAccrualQuartersReducer = (state = InitialState.calculableAccrualQuarters, action) => {
  switch (action.type) {
    case types.LOAD_CALCULABLE_QUARTERS:
      return action.quarters;
    default:
      return state;
  }
};

export default calculableAccrualQuartersReducer;
